import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
// import Paper from '@mui/material/Paper';
// import Draggable from 'react-draggable';
import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, useMediaQuery } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Webcam from 'react-webcam';
import ButtonAction from 'src/components/Button.js/SaveButton';
import Iconify from 'src/components/iconify';
import TextInput from 'src/components/Input/TextInput';
import Loader from 'src/components/loader/loader';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import NotificationHikvisionModal from 'src/components/modal/NotificationHikvisionModal';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import crypt from 'src/utils/service/crypt';
// function PaperComponent({ ...props }) {
//     return (
//         <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
//             <Paper {...props} />
//         </Draggable>
//     );
// }

const videoConstraints = {
    // width: '100%',
    // height: '80%',
    // facingMode: 'user',
    // autoGainControl: false, // Fix lỗi màn hình xanh trên Safari iOS
    facingMode: 'user', // Dùng "environment" nếu cần camera sau
    width: { ideal: 640 },
    height: { ideal: 480 },
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function RegisterFaceIDModal({
    visible = false,
    dataUpdate,
    setVisible,
    fuctGet,
    handleSave,
    loader,
    title,
    mesages,
}) {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const webcamRef = useRef(null);
    const [imgSrc, setImgSrc] = useState(null);

    const addFlag = React.useRef(false);
    const [flagAddStat, setFlagAddStat] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const imageName = useRef('');
    const dataReqImg = useRef({
        imgType: '',
        image_data: '',
        size: 0,
        encodeType: 'base64',
    });
    const [imgUserExists, setImgUserExists] = useState(null);

    const [visibleDel, setVisibleDel] = useState(false);
    const delFlags = useRef(false);
    const [deleleFlags, setDeleleFlags] = useState(false);
    const [isDelete, setIsDelete] = useState(false);

    const [visibleNotification, setVisibleNotification] = useState(false);
    const [dataNotification, setDataNotification] = useState([]);
    const [errCamera, setErrCamera] = useState(null);

    const menu = sessionStorage.getItem('menu');
    let screenPermissions = {};

    if (menu) {
        try {
            const data = JSON.parse(crypt.deCode(menu));
            // console.log('Loading menu', data[0]);
            screenPermissions = data[0].filter((item) => item.screens_key === 'ds_nv')[0];
            // console.log('screenPermissions', screenPermissions);
        } catch (error) {}
    }
    // Kiểm tra quyền truy cập camera
    const checkCameraPermission = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            setHasPermission(true);
            stream.getTracks().forEach((track) => track.stop()); // Dừng stream sau khi kiểm tra
        } catch (error) {
            console.error('Camera permission denied:', error);
            toast.error('Camera permission denied: ' + JSON.stringify(error));
            setHasPermission(false);
        }
    };

    useEffect(() => {
        checkCameraPermission();
    }, []);
    useEffect(() => {
        setImgUserExists(`${glb_sv.urlGetFaceImage(dataUpdate.face_img_nm)}`);
    }, [dataUpdate]);

    const capturePhoto = useCallback(async () => {
        try {
            const imageSrc = webcamRef.current.getScreenshot();
            setImgSrc(imageSrc);
            const imageSizeInBytes = new TextEncoder().encode(imageSrc).length;
            setTimeout(() => {
                dataReqImg.current = {
                    imgType: 'image/jpeg',
                    image_data: imageSrc.toString().replace(/^data:image\/\w+;base64,/, ''),
                    size: imageSizeInBytes,
                    encodeType: 'base64',
                    typeUpload: '1',
                };
            }, 400);
        } catch (error) {
            console.error('Error capturing photo:', error);
        }
    }, [webcamRef]);

    let sum = 0;
    const uploadFile = async () => {
        if (dataReqImg.current.image_data) {
            try {
                const req = await axios.post(glb_sv.urlPostFaceImage, {
                    imgType: dataReqImg.current.imgType,
                    image_data: dataReqImg.current.image_data,
                    size: dataReqImg.current.size,
                    encodeType: dataReqImg.current.encodeType,
                    typeUpload: dataReqImg.current.typeUpload,
                });
                console.log('req', req);

                if (req?.data?.success) {
                    const data = req.data.data;
                    imageName.current = data.imageName;
                    sum = sum + 1;
                    // toast.success(t('action_success_'));
                } else {
                    toast.error('error uploading image');
                }
            } catch (error) {}
        }
        if (!imageName.current || imageName.current === '') {
            return toast.error(t('error.upload'));
        }
        if (imageName.current) {
            addFlag.current = true;
            setFlagAddStat(true);
            // console.log(imageName)
            const InVal = [dataUpdate.id, imageName.current];
            sendRequest(serviceList.registerFaceID, InVal, actionResult, true, timeOutFunct, 45000);
            setImgSrc(null);
        }
    };

    const actionResult = (reqInfoMap, message) => {
        addFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            if (message['proc_code'] !== 'HRM027') {
                setDataNotification(message.proc_data.rows[0].o_1);
                setVisibleNotification(true);
            }
            return;
        } else {
            if (message['proc_code'] === 'HRM026') {
                toast.warning(message['proc_message']);
            } else {
                toast.success(message['proc_message']);
            }
            setDataNotification(message.proc_data.rows[0].o_1);
            setVisibleNotification(true);
            // fuctGet && fuctGet();
            // setVisible(!visible);
        }
    };
    const timeOutFunct = (reqInfo) => {
        setFlagAddStat(false);
        toast.error(t('error.time_out'));
    };

    const handleRefresh = useCallback(() => {
        setImgSrc(null);
        setImgUserExists(null);
    }, [webcamRef]);

    const handleCancel = () => {
        setVisible(false);
        setImgSrc(null);
        if (dataUpdate.face_img_nm) {
            setImgUserExists(`${glb_sv.urlGetFaceImage(dataUpdate.face_img_nm)}`);
        }
    };

    const handleDelete = () => {
        if (!dataUpdate.id) return toast.error(t('error.system_error'));
        if (delFlags.current) {
            return;
        }
        setDeleleFlags(true);
        delFlags.current = true;
        const InVal = [dataUpdate.id];
        sendRequest(serviceList.deleteFaceID, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const deleteResult = (reqInfoMap, message) => {
        setDeleleFlags(false);
        delFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setDataNotification(message.proc_data.rows[0].o_1);
            setVisibleDel(false);
            setIsDelete(true);
            setVisibleNotification(true);
            return;
        } else {
            if (message['proc_code'] === 'HRM026') {
                toast.warning(message['proc_message']);
            } else {
                toast.success(message['proc_message']);
            }
            setDataNotification(message.proc_data.rows[0].o_1);
            setVisibleDel(false);
            setIsDelete(true);
            setVisibleNotification(true);
            // fuctGet && fuctGet();
            setImgUserExists(null);
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        setDeleleFlags(false);
        delFlags.current = false;
        toast.error(t('error.time_out'));
    };

    const isImageUrl = (url) => {
        // Simple regex to check if the URL has common image file extensions
        const imgExtensions = /\.(png|jpg|jpeg|gif|bmp|webp)$/i;
        return imgExtensions.test(url);
    };

    return (
        <>
            <BootstrapDialog
                fullScreen={fullScreen}
                open={visible}
                // onClose={() => setVisible(false)}
                aria-labelledby="customized-dialog-title"
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleCancel}>
                    {t('register_face_id')}
                </BootstrapDialogTitle>
                <Loader loading={flagAddStat || deleleFlags} />
                <ConfirmModal visible={visibleDel} setVisible={setVisibleDel} handleDelete={handleDelete} />
                <NotificationHikvisionModal
                    type={'faceID'}
                    visibleNotification={visibleNotification}
                    setVisibleNotification={setVisibleNotification}
                    visibleRegister={visible}
                    setVisibleRegister={setVisible}
                    dataNotification={dataNotification}
                    fuctGet={fuctGet}
                    isDelete={isDelete}
                    setIsDelete={setIsDelete}
                />
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xl={12} md={6} sm={6} style={{ width: '100%' }}>
                            <TextInput label={t('code_staff')} valueChange={dataUpdate.id} disabled />
                        </Grid>
                        <Grid item xl={12} md={6} sm={6} style={{ width: '100%' }}>
                            <TextInput label={t('name_staff')} valueChange={dataUpdate.user_nm} disabled />
                        </Grid>
                        {isImageUrl(imgUserExists) ? (
                            <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                                <img
                                    style={{
                                        width: '100%',
                                        height: '80%',
                                        objectFit: 'cover',
                                    }}
                                    src={imgUserExists}
                                    alt="imgUser"
                                />
                            </Grid>
                        ) : (
                            <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                                {imgSrc ? (
                                    <img
                                        style={{
                                            width: '100%',
                                            height: '80%',
                                            objectFit: 'cover',
                                        }}
                                        src={imgSrc}
                                        alt="webcam"
                                    />
                                ) : (
                                    <>
                                        {!hasPermission && (
                                            <ButtonAction
                                                title={t('hasPermission')}
                                                type="other"
                                                startIcon={<Iconify icon="basil:refresh-solid" />}
                                                onClick={checkCameraPermission}
                                            />
                                        )}
                                        {hasPermission && (
                                            <Webcam
                                                audio={false}
                                                height={'80%'}
                                                width={'100%'}
                                                ref={webcamRef}
                                                screenshotFormat="image/jpeg"
                                                videoConstraints={videoConstraints}
                                                playsInline // Thêm dòng này
                                                onUserMedia={() => toast.success(t('cameraStarted'))}
                                                onUserMediaError={(error) =>
                                                    toast.error(t('cameraError:') + JSON.stringify(error))
                                                }
                                                muted
                                            />
                                        )}
                                    </>
                                )}
                            </Grid>
                        )}

                        {/* <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                            <WebcamCapture></WebcamCapture>
                        </Grid> */}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonAction
                        disabled={flagAddStat || deleleFlags}
                        title={t('cancel')}
                        onClick={handleCancel}
                        type="cancel"
                    />
                    {isImageUrl(imgUserExists) ? (
                        <>
                            {screenPermissions?.delete_permission === '1' && (
                                <ButtonAction
                                    disabled={flagAddStat || deleleFlags}
                                    title={t('delete')}
                                    type="delete"
                                    onClick={() => setVisibleDel(true)}
                                />
                            )}
                            {screenPermissions?.update_permission === '1' && (
                                <ButtonAction
                                    disabled={flagAddStat || deleleFlags}
                                    title={t('refresh')}
                                    type="other"
                                    startIcon={<Iconify icon="basil:refresh-solid" />}
                                    onClick={handleRefresh}
                                />
                            )}
                        </>
                    ) : (
                        <>
                            {imgSrc ? (
                                <>
                                    <ButtonAction
                                        disabled={flagAddStat || deleleFlags}
                                        title={t('refresh')}
                                        type="other"
                                        startIcon={<Iconify icon="basil:refresh-solid" />}
                                        onClick={handleRefresh}
                                    />
                                    <ButtonAction
                                        disabled={flagAddStat || deleleFlags}
                                        title={t('register')}
                                        type="save"
                                        onClick={uploadFile}
                                    />
                                </>
                            ) : (
                                <ButtonAction
                                    disabled={flagAddStat || deleleFlags}
                                    title={t('capture_register_faceID')}
                                    type="other"
                                    startIcon={<Iconify icon="material-symbols:camera-outline" />}
                                    onClick={capturePhoto}
                                />
                            )}
                        </>
                    )}
                </DialogActions>
            </BootstrapDialog>
        </>
    );
}
